import { Metamodel } from 'app/model/base/model';
import { ExcelDataset } from 'app/model/dataset/excel.dataset';
import { DataFlowExpression } from '../dataflowexpression';
import { FileBasedSettings, FILEMODE } from './file-based-settings';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { compressionOptionValues } from 'app/shared/components/compression-setting/compression-options';
import { IntegerDataFlowType, StringDataFlowType } from 'worker/app-workers/shared/models/dataflow-datatype';
import { IViolation } from 'app/model/base/annotation';
import { DataFlowSource } from '../dataflow-source';

import { compressionCodecType, IValidationContext } from 'shell-models-lib';
import { validateFilePathOfFileBasedSettings } from './dataset-settings-validation-utils';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.excel.dataflowSettings,
    validator: ExcelSettings.validateExcelSettings
})
export class ExcelSettings extends FileBasedSettings {
    public compressionType: string;
    public compressionLevel: DataFlowExpression;
    public sheetName: DataFlowExpression;
    public sheetIndex: DataFlowExpression;
    public useSheetName: boolean;
    public range: DataFlowExpression;
    public firstRowAsHeader: DataFlowExpression;
    public nullValue: DataFlowExpression;

    public getDatasetType(): string {
        return Metamodel.modelFor(ExcelDataset).name;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Excel;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getIconClass(): string {
        return 'i-20x20-excel';
    }

    public initialize(subFormat: string): void {
        super.initialize(subFormat);
        this.compressionLevel = this.transform.createTemplatableExpression(StringDataFlowType.TYPE, compressionOptionValues.Fastest);
        this.sheetName = this.transform.createTemplatableExpression();
        this.sheetIndex = this.transform.createTemplatableExpression(IntegerDataFlowType.TYPE);
        this.useSheetName = true;
        this.range = this.transform.createTemplatableExpression();
        this.firstRowAsHeader = this.transform.createTemplatableExpression();
        this.nullValue = this.transform.createTemplatableExpression();
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateExcelSettings(settings: ExcelSettings, context: IValidationContext): Promise<IViolation[]> {
        const source = settings.transform as DataFlowSource;
        if (source.isInlineDataset && source.datasetSettings && source.datasetSettings.getFormat() === DatasetFormatType.Excel) {
            const violations: IViolation[] = [];
            violations.push(...(await validateFilePathOfFileBasedSettings(settings, false, context)));
            if (settings.useSheetName && !settings.sheetName.expression) {
                violations.push({
                    context: source,
                    message: () => stringResources.Dataflow_RequireSheetName
                });
            }
            if (!settings.useSheetName && !settings.sheetIndex.expression) {
                violations.push({
                    context: source,
                    message: () => stringResources.Dataflow_RequireSheetIndex
                });
            }
            if (settings.fileMode === FILEMODE.FILE && settings.compressionType === compressionCodecType.gzip &&
                !settings.fileName.templateExpression && !!settings.fileName.expression && !settings.fileName.expression.endsWith('.gz')) {
                violations.push({
                    message: () => stringResources.Dataset_FileFormat_GZipFilenameError,
                    context: source
                });
            }
            return violations.length > 0 ? violations : undefined;
        }
        return undefined;
    }
}
